import { DateTime } from 'luxon';

export const processFormalizacionResponse = (included) => {
  const formalizacionModel = {};
  if (included && included.length > 0) {
    included.forEach((rel) => {
      if (rel.type === 'node--date_assignement') {
        formalizacionModel.fechaFirma = DateTime.fromISO(rel.attributes.f_firma_notario).setLocale('es').toFormat("yyyy-MM-dd'T'HH:mm:ss.SSS");
      //  formalizacionModel.fechaFirma = DateTime.fromISO(rel.attributes.f_firma_notario).toISODate();
      }
      if (rel.type === 'node--notary') {
        formalizacionModel.nombre = rel.attributes.nt_nombre;
        formalizacionModel.apellidos = rel.attributes.nt_apellidos;
        formalizacionModel.id = rel.attributes.uuid;
        formalizacionModel.title = rel.attributes.title;
      }
    });
    return formalizacionModel;
  }
  return {};
};

export const processDistributionPledge = (included) => {
  const distributionData = {};
  if (included && included.length > 0) {
    distributionData.value = included[0].attributes.value;
    distributionData.percentage = included[0].attributes.percentage;
    distributionData.idDistribution = included[0].id;
    return distributionData;
  }
  return {};
};
export const formatDistributionData = (data) => {
  const attributes = {};
  const relationships = {};
  const id = data.idDistribution && data.idDistribution.length > 0 ? data.idDistribution : undefined;

  if (data.id) {
    attributes.title = data.id;
  }
  if (data.id && data.idDistribution) {
    attributes.title = `${data.id}-${data.idDistribution}`;
  }
  if (data.value) {
    attributes.value = data.value;
  }
  if (data.percentage) {
    attributes.percentage = data.percentage;
  }
  return {
    data: {
      id,
      type: 'node--distribution_pledge',
      attributes,
      relationships,
    },
  };
};

export const formatPledgeRelation = (pledge, distribution) => {
  const relationships = {};
  if (pledge.id && distribution.id) {
    relationships.distribution_pledge = {
      data: {
        type: 'node--distribution_pledge',
        id: distribution.id,
      },
    };
  }
  return {
    data: {
      id: pledge.id,
      type: 'node--pledge',
      relationships,
    },
  };
};



// WEBPACK FOOTER //
// ./src/features/formalizacion/utils.js